import { render, staticRenderFns } from "./nxMobileNumber.vue?vue&type=template&id=4baa4eba&scoped=true&"
import script from "./nxMobileNumber.vue?vue&type=script&lang=js&"
export * from "./nxMobileNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa4eba",
  null
  
)

export default component.exports